import React from "react";
import {
  ICheckboxesElement,
  ISelectElement,
  IRadioButtonsElement,
} from "@graffer-inc/form-schema";

type Props = {
  element: ICheckboxesElement | ISelectElement | IRadioButtonsElement;
};

export const SelectableOptionsEditor: React.FC<Props> = ({ element }) => {
  return (
    <div className="field">
      <div className="is-flex is-justify-content-space-between is-align-items-center mb-4">
        <label
          className="label"
          htmlFor={`${element.id}-options`}
          style={{
            marginBottom: 0,
          }}
        >
          選択肢一覧
        </label>
      </div>

      <table className="table is-fullwidth">
        <thead>
          <tr>
            <th>表示名</th>
            <th>管理用コード</th>
            <th
              style={{
                width: "50px",
              }}
            ></th>
          </tr>
        </thead>
        <tbody>
          {element.enum.map(({ text, value }) => {
            return (
              <tr key={`selectable-options-table-tr-${value}`}>
                <td
                  style={{
                    verticalAlign: "middle",
                  }}
                >
                  <p>{text}</p>
                </td>
                <td>
                  <p>{value}</p>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
